export interface EducationOption {
  id: number;
  name: string;
  specializationId: number;
}

type EducationState = {
  selectedEducationOptions: EducationOption[];
};
  
export const educationInitialState: EducationState = {
  selectedEducationOptions: [],
};